import { useParams } from 'react-router-dom';
import { iframeOnLoadHelper } from '../../../helper/iframeOnLoadHelper';
import { ELDA_URL } from '../../../variables';
import Terms from '../../components/common/Terms';

const ApiIdPage = () => {

    const params = useParams();

    let src = '';

    let id = params ? params["*"] : undefined;

    if(!id || id === "undefined"){
        src = `${ELDA_URL}/id`
    } else {
        src = `${ELDA_URL}/id/${id}`
    }

    if(src.endsWith("/")){
        src = src.slice(0, -1);
    }

    return (
        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <iframe
                title="ApiIdPage"
                src={src}
                style={{ width: '100%', height: 'calc(100vh - 95px)' }}
                onLoad={iframeOnLoadHelper}
            />
            <Terms />
        </div>
    );
};

export default ApiIdPage;
